<div>
  <div *ngIf="!isLoading && !!selectedLocus" class="details-container" [ngClass]="{'expanded': detailsElement?.open}"
    role="region" [attr.aria-label]="'iaa.app.locus.locusDetails.locusDetails' | translate">
    <div [ngClass]="{'directionDesc flex flex-row':true,'en': descriptionDirection === 'ltr','he': descriptionDirection === 'rtl' }">
      <div class="description"
        *ngIf="selectedLocus.locusDescription.length > 290">{{selectedLocus.locusDescription.slice(0,290)+' ...' }}
      </div>
      <div  class="description"
        *ngIf="selectedLocus.locusDescription.length <= 290">{{selectedLocus.locusDescription}}
      </div>
      <app-show-more-dialog [contentText]="selectedLocus.locusDescription"
        [headerText]="'iaa.app.locus.locusDetails.locusDescription' | translate" [minLength]="290"
        [currentLanguage]="currentLanguage" [descriptionDirection]="descriptionDirection"></app-show-more-dialog>
    </div>
    <div class="body-wrapper">
      <div class="grid-table details">
        <div class="flex flex-column w-full">
          <div class="details-row">
            <div class="detail-item-container">
              <div class="cutting-item-label">{{'iaa.general.expedition' | translate}}</div>
              <div class="detail-item-value">{{ (selectedLocus?.locusExpedition?.expeditionName || '') | translateLang |
                async }}</div>
            </div>
            <div class="detail-item-container">
              <div class="cutting-item-label">{{'iaa.general.license' | translate }}</div>
              <div class="detail-item-value">{{ getLicencesListNames(selectedLocus?.locusLicenses) }}</div>
            </div>
            <div class="detail-item-container">
              <div class="cutting-item-label">{{'iaa.app.locus.surface' | translate}}</div>
              <div class="detail-item-value">{{ selectedLocus?.areaName }}</div>
            </div>
            <div class="detail-item-container">
              <div class="cutting-item-label">{{'iaa.general.period' | translate}}</div>
              <div class="detail-item-value">{{ (selectedLocus?.locusPeriod?.wordName || '') | translateLang | async}}
              </div>
            </div>
          </div>
          <div class="details-row">
            <div class="detail-item-container">
              <div class="cutting-item-label" style="color: var(--iaa-color-002649)">
                {{'iaa.app.locus.locusDetails.locusType' | translate}}</div>
              <div class="detail-item-value" style="color: #5D5D5D">{{ (selectedLocus?.locusMainType?.wordName || '') |
                translateLang | async}}</div>
            </div>
            <div class="detail-item-container">
              <div class="cutting-item-label" style="color: var(--iaa-color-002649)">
                {{'iaa.app.locus.locusDetails.secondaryLocusType' | translate}} </div>
              <div class="detail-item-value" style="color: #5D5D5D">{{ (selectedLocus.locusType?.wordName || '') |
                translateLang | async }}</div>
            </div>
            <div class="detail-item-container">
              <div class="cutting-item-label">{{'iaa.app.locus.locusDetails.openingDate' | translate}} </div>
              <div class="detail-item-value">{{ selectedLocus.locusOpenedDate | validDate | date: "dd.MM.yyyy" }}</div>
            </div>
            <div class="detail-item-container">
              <div class="cutting-item-label"> {{'iaa.app.locus.locusDetails.closingDate' | translate}}</div>
              <div class="detail-item-value">{{ selectedLocus.locusClosedDate | validDate | date: "dd.MM.yyyy" }}</div>
            </div>
          </div>
          <div class="details-row last">
            <div class="detail-item-container">
              <div class="cutting-item-label"> {{'iaa.app.locus.locusDetails.topHeight' | translate}}</div>
              <div class="detail-item-value">{{ selectedLocus.locusHighHeight }}</div>
            </div>
            <div class="detail-item-container">
              <div class="cutting-item-label" style="color: var(--iaa-color-002649)">
                {{'iaa.app.locus.locusDetails.bottomHeight' | translate}} </div>
              <div class="detail-item-value" style="color: #5D5D5D">{{ selectedLocus.locusLowHeight }}</div>
            </div>
            <div class="detail-item-container">
              <div class="cutting-item-label" style="color: var(--iaa-color-002649)">{{'iaa.app.locus.locusDetails.unit'
                | translate}}</div>
              <div class="detail-item-value" style="color: #5D5D5D">{{ selectedLocus.locusUnit }}</div>
            </div>
            <div class="detail-item-container">
              <div class="cutting-item-label" style="color: var(--iaa-color-002649)">
                {{'iaa.app.locus.locusDetails.layer' | translate}}</div>
              <div class="detail-item-value" style="color: #5D5D5D">{{ selectedLocus.locusPhase }}</div>
            </div>
          </div>
        </div>
      </div>
      <app-image-gallery *ngIf="images.length" [images]="images" [thumbnails]="thumbnails" class="gallery"
        [objectName]="('iaa.app.locus.locus' | translate) + ' ' + selectedLocus?.locusName" />
    </div>
    <div class="locus-surrounding flex flex-column w-full">
      <details #detailsElement>
        <summary>
          <div class="tangent-summary">
            <div class="tangent-title">{{ ('iaa.app.locus.locusDetails.surroundingLocuses' | translate) + ' (' +
              (sorroundingLociCount) + ')' }}</div>
            <div class="icons">
              <i [ngClass]="{'pi pi-angle-left icon-default':true, 'en': (currentLanguage| async) === 'en'}"></i>
              <i class="pi pi-angle-down icon-clicked"></i>
            </div>
          </div>
        </summary>
        <div class="flex flex-column">
          <div class="cutting-item-container first">
            <div class="cutting-item-label">{{ 'iaa.app.locus.locusDetails.locusAbove' | translate }} </div>
            <div class="cutting-item-value">
              <button class="redirect-to-locus" role="button" [tabindex]="0"
                *ngFor="let item of selectedLocus.surroundingLoci.lociAbove; let last = last"
                (click)="goToLocus(item.locusId)" (keydown.enter)="goToLocus(item.locusId)">
                {{ item.locusName }}{{ !last ? ', ' : '' }}
              </button>
            </div>
          </div>
          <div class="cutting-item-container">
            <div class="cutting-item-label">{{ 'iaa.app.locus.locusDetails.cuttingLocus' | translate }} </div>
            <div class="cutting-item-value">
              <button class="redirect-to-locus" role="button" [tabindex]="0"
                *ngFor="let item of selectedLocus.surroundingLoci.lociCutsInto; let last = last"
                (click)="goToLocus(item.locusId)" (keydown.enter)="goToLocus(item.locusId)">
                {{ item.locusName }}{{ !last ? ', ' : '' }}
              </button>
            </div>
          </div>
          <div class="cutting-item-container">
            <div class="cutting-item-label">{{ 'iaa.app.locus.locusDetails.locusBelow' | translate }} </div>
            <div class="cutting-item-value">
              <button class="redirect-to-locus" role="button" [tabindex]="0"
                *ngFor="let item of selectedLocus.surroundingLoci.lociBelow; let last = last"
                (click)="goToLocus(item.locusId)" (keydown.enter)="goToLocus(item.locusId)">
                {{ item.locusName }}{{ !last ? ', ' : '' }}
              </button>
            </div>
          </div>
          <div class="cutting-item-container">
            <div class="cutting-item-label">{{ 'iaa.app.locus.locusDetails.locusCutOff' | translate }} </div>
            <div class="cutting-item-value">
              <button class="redirect-to-locus" role="button" [tabindex]="0"
                *ngFor="let item of selectedLocus.surroundingLoci.lociCutBy; let last = last"
                (click)="goToLocus(item.locusId)" (keydown.enter)="goToLocus(item.locusId)">
                {{ item.locusName }}{{ !last ? ', ' : '' }}
              </button>
            </div>
          </div>
          <div class="cutting-item-container">
            <div class="cutting-item-label">{{ 'iaa.app.locus.locusDetails.adjacentLocus' | translate }} </div>
            <div class="cutting-item-value">
              <button class="redirect-to-locus" role="button" [tabindex]="0"
                *ngFor="let item of selectedLocus.surroundingLoci.lociAdjointsInto; let last = last"
                (click)="goToLocus(item.locusId)" (keydown.enter)="goToLocus(item.locusId)">
                {{ item.locusName }}{{ !last ? ', ' : '' }}
              </button>
            </div>
          </div>
        </div>
      </details>
    </div>
  </div>
</div>